module.exports = __webpack_public_path__ + "static/media/ic_email_white_36px.db57b166.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ic_email_white_36px.svg
// module id = 251
// module chunks = 0